export const DEFAULT_EVENTS_TAB = 'upcoming';
